import Swal from "sweetalert2";
import { translateErrorText } from "./errorMessageTranslations";

function parseJsonBody(body) {
  if (typeof body !== "string") {
    return body;
  }

  try {
    return JSON.parse(body);
  } catch {
    return body;
  }
}

function getValidationMessages(data) {
  const errors =
    (Array.isArray(data?.detail?.errors) && data.detail.errors) ||
    (Array.isArray(data?.detail) && data.detail) ||
    (Array.isArray(data?.errors) && data.errors);

  if (!errors) {
    return null;
  }

  const messages = errors
    .map((item) => item?.msg)
    .filter((message) => typeof message === "string" && message.trim());

  return messages.length ? messages.join("\n") : null;
}

export function showErrorAlert(error) {
  const data = parseJsonBody(
    error?.response?.data || error?.data || error?.body || error,
  );

  const status =
    data?.status ||
    data?.statusCode ||
    error?.response?.status ||
    error?.status ||
    error?.statusCode;

  const title = status ? `Error ${status}` : "Error";

  const rawText =
    getValidationMessages(data) ||
    data?.message ||
    data?.detail?.message ||
    data?.error ||
    error?.message ||
    (typeof data === "string" ? data : JSON.stringify(data, null, 2));

  const text = translateErrorText(rawText, status);

  Swal.fire({ title, text, icon: "error" });
}
